import React, { Fragment, useState, useEffect } from 'react'
import { Formik, Field, Form } from 'formik';
import FormikFieldGroup from './shared/FormikFieldGroup'
import FormikRadioGroup from './shared/FormikRadioGroup'
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { getQuestions } from '../../store/actions/membershipActions'
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';

import PaymentFormSignup from '../ui/paymentForm'
import { FormControlLabel, TextareaAutosize } from '@material-ui/core'
import PhoneInput from './phoneInputCustom';
import Radio from '@material-ui/core/Radio';
import moment from 'moment'

const styles = (theme) => ({
    padding2: {
        padding: theme.spacing(2)
    },
    padding3: {
        padding: theme.spacing(3)
    },
    playerContainer: {
        marginTop: theme.spacing(2)
    },
    marginTop3: {
        marginTop: theme.spacing(3)
    },
    marginTop8: {
        marginTop: theme.spacing(8)
    },
    marginTop5: {

        marginTop: theme.spacing(5)
    },
    marginTop2: {
        marginTop: theme.spacing(2)
    },
    marginTopVe:{
        marginTop: -theme.spacing(2)
    },
    button: {
        paddingRight: theme.spacing(4),
        paddingLeft: theme.spacing(4),
        letterSpacing: '1px',
        '&:focus, &:hover, &:visited, &:link, &:active': {
            background: 'transparent'
        }
    },
    buttonPay: {
        '&:focus, &:hover, &:visited, &:link, &:active': {
            background: theme.palette.primary.main
        }
    },
    buttonCustomDashed: {
        color: '#009BE1',
        background: 'white',
        fontWeight: 600,
        border: '2px dashed #009BE1'

    },
    marginBottom2: {
        marginBottom: theme.spacing(3)
    },
    marginBottom1: {
        marginBottom: theme.spacing(1)
    },
    bold: {
        fontWeight: '600'
    },
    muted: {
        color: theme.palette.text.disabled
    },
    bgTransparent: {
        backgroundColor: 'transparent'
    },
    smallText: {
        fontSize: theme.spacing(1.75)
    },
    center: {
        textAlign: 'center'
    },
    subText: {
        fontWeight: 500,
        paddingLeft: theme.spacing(2)
    },
    link: {
        color: theme.palette.primary.main + ' !important',
        cursor: 'pointer'
    },
    header: {
        marginBottom: theme.spacing(3),
        fontWeight: 500,
        color: 'grey'
    },
    datePicker: {
        background: theme.palette.background.default,
        height: '60px',
        paddingLeft: '12px'
    },
    errorMessage: {
        color: theme.palette.error.main,
        height: '20px',
        fontSize: '12px',
        position: 'relative',
        right: 0,
        textAlign: 'right',
        background: 'white'
    },
    textArea: {
        width: '100%', 
        padding: '12px', 
        borderRadius: '0', 
        border: 'none', 
        background:'#f7f9fa',
         '&:focus': {
            outline: 'none',
            border: 'none', 
        },
    },
    subHeader: {
        fontWeight: '600',
        color: '#444746'
    },
    phoneInputWrapper: {
        marginBottom: '16px'
    }

});

const Questions = ({ classes, regId, selectedRegMeta,  resetFn, registerFormValues, regTitle, membershipRegs }) => {

    const dispatch = useDispatch()
    const questions = useSelector(state => state.memberships.questions)
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [paymentDisplay, setPaymentDisplay] = useState(false)
    const [additionalInfo, setAdditionalInfo] = useState({})
    const [answers, setAnswers] = useState({})
    const [emergencyContactNumberInState, setEmergencyContactNumInState] = useState('')
    const [phoneNumInState, setPhoneNumInState] = useState('')
    const [phoneNumErr, setPhoneNumErr] = useState(undefined)
    const [emergencyPhoneNumErr, setEmergencyPhoneNumErr] = useState(undefined)
    const [address, setAddress] = useState('')
    const [mailingAddress, setMailingAddress] = useState('')
    const [dobErr, setDobErr] = useState(undefined)
    const [displayAddtnlFamilyQues, setDisplayAddtnlFamilyQues] = useState(false);
    const [minDob, setMinDob] = useState(new Date().toISOString())
    const [sameMailingAddress, setSameMailingAddress] = useState(true)

    useEffect(()=> {
        if(regTitle === 'Full Golf Membership' || regTitle === 'Social Membership'){
            setMinDob(moment().subtract('years', 18))
        }
    }, [])
   
    const handleDateChange = (date) => {
        setSelectedDate(date);
    };
    const handleEmergencyPhoneChangeFn = (val) => {
        setEmergencyContactNumInState(val)
    }

    const onAddressChange = (e) => {
        setAddress(e.target.value)
    
    }
    const onMailingAddressChange = (e) => {
        setMailingAddress(e.target.value)
    }

    const handlePhoneChangeFn = (val) => {
        setPhoneNumInState(val)
    }

    const handleSameMailingAddress = (e) => {
        setSameMailingAddress(e.target.checked)
    }

    const handleRegister = (values, {
        setFieldError
    }) => {

        if (phoneNumInState === '') {
            setPhoneNumErr(true)
        }

        if(emergencyContactNumberInState === ''){
            setEmergencyPhoneNumErr(true)
        }
       
        if(!phoneNumInState || phoneNumInState === '' ||  !emergencyContactNumberInState || emergencyContactNumberInState === '' || dobErr)
        {
            return
        }
        let mailingAddressInfo = (sameMailingAddress === true) ? '': mailingAddress
        setAdditionalInfo({
            dateOfBirth: selectedDate,
            emergencyContact: emergencyContactNumberInState,
            emergencyContactName: values.emergencyContactName,
            phoneNumber: phoneNumInState,
            address: address,
            mailingAddress: mailingAddressInfo,
            pob: values.pob,
            referral: values?.referral
        });


        let answersObj = {}
        let excludeFields = ['dob', 'emergencyContactNumber', 'emergencyContact', 'phoneNumber', 'address', 'mailingAddress', 'pob', 'emergencyContactName', 'referral']
        Object.keys(values).forEach(key => {
            if (!excludeFields.includes(key)) {
                answersObj[key] = values[key]
            }
        })

        setAnswers(answersObj)

        setPaymentDisplay(true)

    }
    const resetToQuestions = () => {
        setPaymentDisplay(false)
    }

    useEffect(() => {
        window.scrollTo(0, 0)
        dispatch(getQuestions(regId, (err, questionsInfo) => {}))
    }, [])



    const validate = values => {
        const errors = {}
        questions.forEach((question) => {

            if (question.isMandatory && (values[question._id] === undefined || values[question._id] === '')) {
                errors[question._id] = 'Please answer this question to proceed'
            }

        })

        if (phoneNumInState !== '') {
            setPhoneNumErr(false)
        }
        if(emergencyContactNumberInState !== ''){
            setEmergencyPhoneNumErr(false)
        }

        return errors
    }

    return <div>
        <Formik
            initialValues={{
                dob: new Date().toISOString(),
                emergencyContactName: '',
                pob: ''
            }}
            onSubmit={handleRegister}
            validate={validate}
        >
            {!paymentDisplay ? <Form>

                <Paper className={classnames(classes.marginTop1, classes.padding2, classes.bgTransparent)}>
                    <Grid container justify="space-between" alignItems="baseline" style={{ marginBottom: '24px' }}>
                        <Grid item >
                            <Button variant='outlined' onClick={resetFn} >Back</Button>

                        </Grid>
                        <Grid item>
                            <div className={classes.header}>{regTitle}</div>
                        </Grid>

                    </Grid>

                    <Grid container style={{ marginBottom: '16px' }}>
                        <Grid item xs={12} className={classes.subHeader}> Date of Birth</Grid>
                        <Grid item xs>
                            <Paper>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        disableToolbar
                                        variant="inline"
                                        format="MM/dd/yyyy"
                                        placeholder='MM/dd/yyyy'
                                        margin="normal"
                                        maxDate={minDob}
                                        required={true}
                                        onError={(err) => setDobErr(err) }
                                        style={{ padding: 0, marginTop: '8px' }}
                                        name="dob"
                                        InputProps={{
                                            disableUnderline: true,
                                            className: classes.datePicker
                                        }}
                                        value={selectedDate}
                                        onChange={handleDateChange}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    ></KeyboardDatePicker>
                                </MuiPickersUtilsProvider>
                               {dobErr && <div className={classes.errorMessage}> Please enter a valid dob to proceed</div>}
                            </Paper>
                        </Grid>
                    </Grid>

                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} className={classes.subHeader}> Place of Birth </Grid>

                        <Grid item xs><Paper>  <FormikFieldGroup
                            label={'Place of Birth'}
                            name={'pob'}
                            placeholder={'City, State'}
                            type='text'
                            elevation={2}
                            padding={12}
                        /></Paper></Grid>
                    </Grid>
                    
                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} className={classes.subHeader}> Phone </Grid>

                        <Grid item xs={12} className={classes.phoneInputWrapper}><Paper>
                            <PhoneInput value={phoneNumInState} handlePhoneChange={handlePhoneChangeFn}></PhoneInput>
                            {phoneNumErr && <div className={classes.errorMessage}> Please enter phone number to proceed</div>}
                        </Paper></Grid>
                    </Grid>

                     <Grid container spacing={1} alignItems="center">
                            <Grid item xs={12} className={classes.subHeader}>Home Address</Grid>
                            <Grid item xs={12}>
                                 <Paper>
                                    <TextareaAutosize required name="address" minRows={5} className={classes.textArea} InputProps={{ disableUnderline: true }} fullWidth  value={address} onChange={onAddressChange} />
                                 </Paper>
                                 
                            </Grid>
                            <Grid item xs className={classes.marginTopVe}>
                                <FormGroup aria-label="position" row>
                                    <FormControlLabel
                                        value="end"
                                        control={<Checkbox color="primary" defaultChecked={true} value={sameMailingAddress} onChange={handleSameMailingAddress} />}
                                        label={<div> Mailing address same as home address </div>}
                                        labelPlacement="end"
                                    />
                                </FormGroup>
                            </Grid>

                    </Grid>
                    
                    {(sameMailingAddress === false) && <Grid container spacing={1}alignItems="center">
                            <Grid item xs={12} className={classes.subHeader}>Mailing Address</Grid>
                            <Grid item xs>
                                 <Paper>
                                    <TextareaAutosize required name="mailing_address" minRows={5} className={classes.textArea} InputProps={{ disableUnderline: true }} fullWidth  value={mailingAddress} onChange={onMailingAddressChange} />
                                 </Paper>
                                 
                            </Grid>

                    </Grid>}
                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} className={classes.subHeader}> Emergency Contact Name </Grid>

                        <Grid item xs><Paper>  <FormikFieldGroup
                            label={'Emergency Contact Name'}
                            name={'emergencyContactName'}
                            type='text'
                            required
                            elevation={2}
                            padding={12}
                        /></Paper></Grid>
                    </Grid>

                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} className={classes.subHeader}> Emergency Contact Number </Grid>

                        <Grid item xs={12} className={classes.phoneInputWrapper}><Paper>
                            <PhoneInput value={emergencyContactNumberInState} handlePhoneChange={handleEmergencyPhoneChangeFn}></PhoneInput>
                            {emergencyPhoneNumErr && <div className={classes.errorMessage}> Please enter emergency contact number to proceed</div>}
                        </Paper></Grid>
                    </Grid>

                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} className={classes.subHeader}> Referral Name (Gets them a reward!) </Grid>

                        <Grid item xs><Paper>  <FormikFieldGroup
                            label={'Referral Name'}
                            name={'referral'}
                            type='text'
                            elevation={2}
                            padding={12}
                        /></Paper></Grid>
                    </Grid>


                    {
                        questions.map((question, index) => {
                            return index === 0 ? <Grid container spacing={1} alignItems="center">
                                {question.type != 'releaseform' && <Grid item xs={12} className={classes.subHeader}> {question.question} </Grid>}

                                {question.type != 'releaseform' && question.type != 'radio' ? <Grid item xs>
                                    <Paper><FormikFieldGroup
                                        variant="question"
                                        label={question.question}
                                        name={question._id}
                                        type='text'
                                        elevation={2}
                                        padding={12}
                                    /></Paper>
                                </Grid> : question.type == 'radio' ? <Grid item>

                                    <Field name={question._id}>
                                        {({ field, form, meta }) => {
                                            return (
                                                <FormikRadioGroup form={form} field={field}>
                                                    {question && question.options && question.options.map((option) => (
                                                        <FormControlLabel
                                                            key={option}
                                                            value={option}
                                                            control={<Radio color="primary" />}
                                                            label={option}
                                                        />
                                                    ))}
                                                </FormikRadioGroup>
                                            );
                                        }}
                                    </Field>

                                </Grid> : <Fragment></Fragment>}

                            </Grid> : displayAddtnlFamilyQues ? <Grid container spacing={1} alignItems="center">
                                {question.type != 'releaseform' && <Grid item xs={12} className={classes.subHeader}> {question.question} </Grid>}

                                {question.type != 'releaseform' && question.type != 'radio' ? <Grid item xs>
                                    <Paper><FormikFieldGroup
                                        variant="question"
                                        label={question.question}
                                        name={question._id}
                                        type='text'
                                        elevation={2}
                                        padding={12}
                                    /></Paper>
                                </Grid> : question.type == 'radio' ? <Grid item>

                                    <Field name={question._id}>
                                        {({ field, form, meta }) => {
                                            return (
                                                <FormikRadioGroup form={form} field={field}>
                                                    {question && question.options && question.options.map((option) => (
                                                        <FormControlLabel
                                                            key={option}
                                                            value={option}
                                                            control={<Radio color="primary" />}
                                                            label={option}
                                                        />
                                                    ))}
                                                </FormikRadioGroup>
                                            );
                                        }}
                                    </Field>

                                </Grid> : <Fragment></Fragment>}

                            </Grid> : <Fragment></Fragment>
                        })

                    }

                    {
                        <Fragment>
                            
                            <Grid container className={classes.marginTop2} justify="center">
                                <Grid container item justify="center">
                                    {phoneNumErr && <div className={classes.errorMessage}> Please enter phone number to proceed</div>}
                                </Grid>
                                <Grid container item justify="center">
                                    {dobErr && <div className={classes.errorMessage}> Please enter a valid dob to proceed</div>}
                                </Grid>
                                
                                <Grid item>
                                    <Button type="submit" variant="contained" size="large" name="MakePaymentBtn" color="primary" className={classes.buttonPay} >
                                        Continue to payment
                                    </Button>
                                </Grid>
                            </Grid>
                        </Fragment>
                    }
                </Paper>
            </Form> : <PaymentFormSignup registerFormValues={registerFormValues} additionalInfo={additionalInfo} answers={answers} regId={regId} membershipRegs={membershipRegs} selectedRegistrationMeta={selectedRegMeta} regTitle={regTitle} resetFn={resetToQuestions} ></PaymentFormSignup>}
        </Formik>
    </div >

}


export default withStyles(styles)(Questions)